import React from 'react';

export enum Actions {
  SET_USER = 'SET_USER',
  SET_MARKET = 'SET_MARKET',
}

export type Action =
  | {
      type: Actions.SET_USER;
      payload: CognitoUser;
    }
  | {
      type: Actions.SET_MARKET;
      payload: number;
    };

export interface CognitoUser {
  username: string;
  cognitoGroups: string[];
  attributes: Record<string, any>;
}

export interface AppContextState {
  user?: CognitoUser;
  selectedMarketId?: number;
}

export const reducer = (currentState: AppContextState, action: Action): AppContextState => {
  let state = currentState;
  switch (action.type) {
    case Actions.SET_USER:
      // we need the default market id from the user's attributes
      state = {
        ...state,
        user: action.payload,
        selectedMarketId: (action.payload?.cognitoGroups || []).includes('city_manager')
          ? (
              JSON.parse(action.payload?.attributes['custom:marketIds'] || '[]') as Array<string>
            ).map(Number)[0]
          : 0,
      };
      break;
    case Actions.SET_MARKET:
      state = {
        ...state,
        selectedMarketId: action.payload,
      };
      break;
    default:
      break;
  }
  return state;
};

export type AppContextProps = [AppContextState, React.Dispatch<Action>];

export const AppStateContext = React.createContext<AppContextProps | null>(null);

export const AppStateContextProvider: React.FC = ({ children }) => {
  const [state, dispatch] = React.useReducer(reducer, {
    user: undefined,
  });
  return <AppStateContext.Provider value={[state, dispatch]}>{children}</AppStateContext.Provider>;
};

export const appActions = {
  setUser: (payload: CognitoUser): Action => ({
    payload,
    type: Actions.SET_USER,
  }),
  setMarket: (payload: number): Action => ({
    payload,
    type: Actions.SET_MARKET,
  }),
};
